<p>create-bundle-included-component works!</p>
